import React, {useEffect, useState} from "react";
import Hero from "../../components/commons/hero/hero.component";
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import "./impersonate-user-list-table.styles.scss"
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, {CSVExport, Search} from 'react-bootstrap-table2-toolkit';
import filterFactory from 'react-bootstrap-table2-filter';
import {useDispatch, useSelector} from "react-redux";
import {getAllImpersonateUsers} from "../../redux/impersonate-users/impersonate.action";
import CustomButton from "../../components/commons/custom-button/custom-button.component";
import Loader from "../../components/commons/helpers/loader/loader.component";
import {useHistory} from "react-router-dom";
import {cartCountUpdate, UpdateImpersonateMember} from "../../redux/shopping-cart/shopping-cart.action";
import {getUserProfileRes} from "../../js/api/auth/_user-profile";

const columns = [{
    dataField: 'UserName',
    text: 'User Name',
    sort: true,
    headerStyle: {
        'width': "30%",
        'white-space': 'nowrap'
    }
}, {
    dataField: 'firstname',
    text: 'First Name',
    sort: true
}, {
    dataField: 'lastname',
    text: 'Last Name',
    sort: true
}, {
    dataField: 'company',
    text: 'Company',
    sort: true
}, {
    dataField: "actions",
    text: "Actions",
    formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
            <CreateCustomInsertButton row={row} />
        );
    }
}
];

export const CreateCustomInsertButton = ({ row }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const getUserProfile = async (memberid) => {
        return await getUserProfileRes(memberid);
    };
    const handleImpersonateClick = async (event) => {

        let fname = event.target.attributes.getNamedItem("fname").value;
        let lname = event.target.attributes.getNamedItem("lname").value;
        let memberid = event.target.id;
        let impersonate = {
            name: (fname ? fname : '') + ' ' + (lname ? lname : ''),
            memberId: memberid
        };
        const getcartitemResponse = await getUserProfile(memberid);
        if (getcartitemResponse) {
            if (getcartitemResponse.User) {
                impersonate.userprofile = getcartitemResponse.User;
            }
        }
        dispatch(UpdateImpersonateMember(impersonate));
        dispatch(cartCountUpdate(1));


        history.push("/shopping-cart");
    }
    return (
        <CustomButton id={row.memberid} fname={row.firstname} lname={row.lastname} onClick={handleImpersonateClick}>Impersonate</CustomButton>
    );
}




const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;

function ImpersonateUserListTableComponent() {

    const dispatch = useDispatch();
    const impersonateUserList = useSelector(
        ({ impersonateUser }) => impersonateUser.impersonateUserList
    );
    const [impUserList, setImpUserList] = useState([]);
    useEffect(() => {
        if (impUserList && impUserList.length === 0) {
            dispatch(getAllImpersonateUsers());
        }
        setImpUserList(impersonateUserList);
    }, [impersonateUserList])



    if (impUserList) {
        return (
            <div className={"user-list-table"}>
                <Hero title={"Impersonate"}
                    template={"standard"}
                    altMobileTitle={true}
                    colorCategory={'gen'}
                />

                <div className="trinity-container">
                    <ToolkitProvider keyField='UserName' bordered={false} data={impUserList} columns={columns} search>
                        {
                            props => (
                                <div>
                                    <SearchBar {...props.searchProps} />
                                    <ExportCSVButton {...props.csvProps}>Export As CSV</ExportCSVButton>
                                    <hr />
                                    <BootstrapTable filter={filterFactory()}
                                        pagination={paginationFactory()}
                                        striped {...props.baseProps}
                                        sort={{ dataField: 'UserName', order: 'asc' }}
                                        bootstrap4
                                    />
                                </div>
                            )}
                    </ToolkitProvider>

                </div>
            </div>
        )
    }
    else {
        return (
            <Loader />
        )
    }
}

export default ImpersonateUserListTableComponent;
